/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ProjectCalculationsScenarioCompareExcelRetrieve$Params {
  /**
   * id эталонного сценария
   */
  baseline: number;

  /**
   * csv id остальных сценариев (≤10)
   */
  others: string;
}

export function projectCalculationsScenarioCompareExcelRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectCalculationsScenarioCompareExcelRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsScenarioCompareExcelRetrieve.PATH, 'get');
  if (params) {
    rb.query('baseline', params.baseline, {});
    rb.query('others', params.others, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

projectCalculationsScenarioCompareExcelRetrieve.PATH = '/api/project_calculations/scenario_compare/excel';
